import newItem from "../../assets/img/staking_items-new.png"
import { SellDialog } from "../../components/dialog/SellDialog"
import { DashboardWelcomeDialog } from "../../components/dialog/DashboardWelcomeDialog"
import { useDialog } from "../../context/DialogContext"
import { useAppSelector } from "../../store"
import { CommanderComponent } from "../NftBoxesCommandersPage"
import {
  Card,
  CardActionArea,
  DialogContentText,
  Grid,
  Stack,
} from "@mui/material"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import Typography from "@mui/material/Typography"
import { useSnackbar } from "notistack"
import React, { useEffect, useRef, useState } from "react"
import PreviewNFTCard from "../../components/card/PreviewNFTCard"
import { PreviewNFTDialog } from "../../components/dialog/PreviewNFTDialog"
import { PreviewOpenedBox } from "../../components/dialog/PreviewOpenedBox"
import { SEO } from "../../components/SEO"
import { PATHS } from "../../constants/paths"
import { getUserNfts } from "../../api/userCommandersApi"
import { openBox } from "../../api/boxes"
import {getUri} from "../../utils/getFullUrl"
import { BASE_URL } from "../../constants/constants"

export const DashboardPage = () => {
  const { user } = useAppSelector((state) => state.user)

  const inventoryRef = useRef(null)
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()

  const [commanders, setCommanders] = useState([])
  const [turrets, setTurrets] = useState([])
  const [nfts, setNfts] = useState([])
  const [boxes, setBoxes] = useState([])
  const [gunOfGame, setGunOfGame] = useState([])

  const [open, setOpen] = useState(false)

  const [isAddedToGame, setAddedToGameOpen] = useState(false)

  const scrollToInventory = () => {
    inventoryRef.current?.scrollIntoView({ behavior: "smooth" })
  }

  const onAddNftToGame = () => {
    setAddedToGameOpen(true)
    enqueueSnackbar("The NFT has been added successfully.", {
      variant: "success",
    })
  }

  const handleOpenNftBox = async (box) => {
    const data = await openBox(user.sessionToken, box)
    if (!data?.success) {
      alert("Error opening box")
      return
    }

    const videoSrc = getUri(
      "video/boxes",
      "mp4",
      data.type,
      data.name,
      data.rarity,
    )

    // Открываем модалку с превью "открытого бокса"
    // Если сервер пришлёт своё имя файла — подхватим его, иначе покажем дефолтное видео.
    openPreviewOpenedBox({
      children: (
        <PreviewOpenedBox
          nft={data.nft}
          closeDialog={closePreviewOpenedBox}
          maxWidth={900}
          videoSrc={videoSrc}
        />
      ),
    })

    await loadUserNfts()
  }

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const items = useAppSelector((state) => state.market.turrets)
  const [marketItems, setMarketItems] = useState(items)

  const [currentCommander, setCurrentCommander] = useState(null)

  const [openSellDialog, closeSellDialog] = useDialog()

  const onSellDepositDialog = (e) => {
    openSellDialog({
      children: <SellDialog closeDialog={closeSellDialog} width={420} />,
    })
  }

  const [openPreviewNFTDialog, closePreviewNFTDialog] = useDialog()

  const [openPreviewOpenedBox, closePreviewOpenedBox] = useDialog()

  const onOpenPreviewNFTDialog = (item, onSellDepositDialog) => {
    openPreviewNFTDialog({
      children: (
        <PreviewNFTDialog
          item={item}
          closeDialog={closePreviewNFTDialog}
          maxWidth={800}
          onSellDepositDialog={onSellDepositDialog}
          onAddNftToGame={onAddNftToGame}
        />
      ),
    })
  }

  // Показать приветственный диалог при загрузке страницы
  const [openWelcomeDialog, closeWelcomeDialog] = useDialog()

  useEffect(() => {
    if (user.address) {
      loadUserNfts()
    }
  }, [user.address])

  const loadUserNfts = async () => {
    // setLoading(true)
    try {
      const data = await getUserNfts(user.sessionToken)

      if (data.success) {
        // если получен NFT в первый раз
        if (data.first_commander !== false) {
          // показываем приветственный диалог
          openWelcomeDialog({
            children: (
              <DashboardWelcomeDialog
                item={data.first_commander}
                closeDialog={() => {
                  closeWelcomeDialog()
                }}
                maxWidth={650}
              />
            ),
          })
        }
        setNfts(data.nfts)
        setBoxes(data.boxes)
      }
    } catch (error) {
      console.error("Error loading commanders:", error)
    }
  }

  return (
    <Box>
      <SEO
        title="Zombie TD | Dashboard - Manage Your Account"
        description="Access your Zombie TD dashboard to track your tokens, NFTs, and rewards."
        ogTitle="Zombie TD | Dashboard"
        ogDescription="Manage your assets, staking, and transactions in the Zombie TD dashboard."
        ogUrl={PATHS.ACCOUNT.PATH}
      />
      <Box id="gun-of-the-game">
        <Typography variant="h3">Commander In the Game</Typography>

        <Grid container spacing={2} mx={"auto"} mt={1} columns={20}>
          <Grid item xs={9} sm={10} md={6} lg={4} display="flex">
            {currentCommander ? (
              <>
                {commanders.map((commander) => {
                  return (
                    <>
                      {commander.title === currentCommander && (
                        <>
                          <CommanderComponent
                            image={getUri(
                              "img",
                              "webp",
                              commander.type,
                              commander.name,
                              commander.rarity,
                            )}
                            video={getUri(
                              "video",
                              "mp4",
                              commander.type,
                              commander.name,
                              commander.rarity,
                            )}
                            lvl={commander.level}
                            rarity={commander.rarity}
                            bonus="30%"
                            progressValue={"85"}
                            progressLabel={"15h. 30m."}
                          />
                          <Button
                            variant={"outlined"}
                            fullWidth
                            sx={{ mt: 1 }}
                            onClick={handleClickOpen}
                          >
                            Change
                          </Button>
                        </>
                      )}
                    </>
                  )
                })}
              </>
            ) : (
              <Box display={"flex"}>
                <Box>
                  <CardActionArea
                    sx={{
                      display: "block",
                    }}
                    onClick={scrollToInventory}
                  >
                    <img
                      src={newItem}
                      alt="Add new"
                      style={{ width: "100%" }}
                    />
                  </CardActionArea>
                </Box>
              </Box>
            )}
          </Grid>

          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title" textAlign={"center"}>
              Upgrade
            </DialogTitle>
            <DialogContent>
              <DialogContentText
                id="alert-dialog-description"
                textAlign={"center"}
                sx={{ mb: 2 }}
              >
                Upgrade
              </DialogContentText>

              <Box>
                <Grid container spacing={3}>
                  {commanders.map((commander) => {
                    return (
                      <>
                        {commander.id > 1 && (
                          <Grid item sm={10} md={6} lg={4}>
                            <Box
                              sx={{
                                filter: "grayscale(1)",
                                "&:hover": {
                                  filter: "grayscale(0)",
                                },
                              }}
                            >
                              <CommanderComponent
                                image={getUri(
                                  "img",
                                  "webp",
                                  commander.type,
                                  commander.name,
                                  commander.rarity,
                                )}
                                video={getUri(
                                  "video",
                                  "mp4",
                                  commander.type,
                                  commander.name,
                                  commander.rarity,
                                )}
                              />
                              <Button
                                variant={"outlined"}
                                fullWidth
                                sx={{ mt: 1 }}
                                onClick={() =>
                                  setCurrentCommander(commander.title)
                                }
                              >
                                Upgrade
                              </Button>
                            </Box>
                          </Grid>
                        )}
                      </>
                    )
                  })}
                </Grid>
              </Box>
            </DialogContent>
          </Dialog>
        </Grid>
      </Box>

      <Box mt={{ xs: 6, sm: 4 }}>
        <Typography variant="h3">Turrets in the game</Typography>

        <Grid container spacing={2} mt={1} mx={"auto"} columns={20}>
          {[1, 2, 3, 4, 5].map((item) => (
            <Grid item xs={9} sm={10} md={6} lg={4} display="flex">
              <Box>
                <CardActionArea
                  sx={{
                    display: "block",
                  }}
                  onClick={scrollToInventory}
                >
                  <img src={newItem} alt="Add new" style={{ width: "100%" }} />
                </CardActionArea>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Boxes */}
      {boxes.length > 0 && (
        <Box mt={{ xs: 6, sm: 4 }} ref={inventoryRef} id="inventory">
          <Typography variant="h3">My NFT Boxes</Typography>
          <Grid container spacing={2} mt={1} mx={"auto"} columns={20}>
            {boxes.map((box) => {
              return (
                <Grid item xs={9} sm={10} md={6} lg={4} display="flex">
                  <Box>
                    <Typography
                      variant={"h5"}
                      sx={{
                        mb: 2,
                        fontSize: {
                          xs: "0.5rem !important",
                          md: "0.7rem !important",
                        },
                      }}
                      textAlign={"center"}
                    >
                      {box.name}
                    </Typography>

                    <Box
                      textAlign="center"
                      sx={{ padding: "16px 0", "& > img": { width: "180px" } }}
                    >
                      <img src={BASE_URL + box.image} alt={box.name} />

                      <Typography variant={"body1"} gutterBottom mt={1}>
                        Amount: <span className="primary">{box.amount}</span>
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mt: 1,
                      }}
                    >
                      <Stack spacing={1} sx={{ width: "100%" }}>
                        <Button
                          variant="contained"
                          size="small"
                          onClick={() => handleOpenNftBox(box)}
                          fullWidth
                        >
                          Open NFT box
                        </Button>
                      </Stack>
                    </Box>
                  </Box>
                </Grid>
              )
            })}
          </Grid>
        </Box>
      )}

      {/* Inventory */}
      <Box mt={{ xs: 6, sm: 4 }} ref={inventoryRef} id="inventory">
        <Typography variant="h3">My Inventory</Typography>

        <Grid container spacing={2} mt={1} mx={"auto"} columns={20}>
          {nfts.map((nft) => {
            return (
              <Grid item xs={9} sm={10} md={6} lg={4} display="flex">
                <Box>
                  <Typography
                    variant={"h5"}
                    sx={{
                      mb: 2,
                      fontSize: {
                        xs: "0.5rem !important",
                        md: "0.7rem !important",
                      },
                    }}
                    textAlign={"center"}
                  >
                    {nft.name}
                  </Typography>

                  <Card>
                    <CardActionArea
                      onClick={() =>
                        onOpenPreviewNFTDialog(nft, onSellDepositDialog)
                      }
                    >
                      <PreviewNFTCard
                        id={nft.id}
                        imageUrl={getUri(
                          "img",
                          "webp",
                          nft.type,
                          nft.name,
                          nft.rarity,
                        )}
                        videoUrl={getUri(
                          "video",
                          "mp4",
                          nft.type,
                          nft.name,
                          nft.rarity,
                        )}
                        lvl={nft.level}
                        rarity={nft.rarity}
                        type={nft.type}
                      />
                    </CardActionArea>
                  </Card>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      mt: 1,
                    }}
                  >
                    <Stack spacing={1} sx={{ width: "100%" }}>
                      <Button
                        variant={"contained"}
                        size={"small"}
                        onClick={onAddNftToGame}
                        // disabled={isAddedToGame}
                        disabled={true}
                        fullWidth
                      >
                        {!isAddedToGame ? "Add to game" : "Added to game"}
                      </Button>
                      <Button
                        variant={"outlined"}
                        size={"small"}
                        fullWidth
                        disabled={true}
                        onClick={onSellDepositDialog}
                      >
                        Sell on the market
                      </Button>
                    </Stack>
                  </Box>
                </Box>
              </Grid>
            )
          })}
        </Grid>
      </Box>
    </Box>
  )
}
